import * as React from "react";
import * as S from "@styled";
import { FocusEvent } from "../../shared/model/Event";
import { EditorProps } from "./EnvironmentVariableEditor";

export class SecretEditor extends React.PureComponent<EditorProps<string>, {}> {
    constructor(props: EditorProps<string>) {
        super(props);
    }

    public render() {
        return (
            <S.FlexContainer>
                <S.PasswordInput
                    placeholder={this.props.value == null ? FRENDS.Localizations.NotSet : "**********"}
                    className="form-control"
                    defaultValue={""}
                    onBlur={this.handleBlur}
                    autoComplete="new-password"
                    isFullWidth={true}
                />
            </S.FlexContainer>
        );
    }

    private handleBlur = (event: FocusEvent<HTMLInputElement>) => {
        // Do not update value if value not set
        if (event.target.value !== "") {
            this.props.updateSingleValue(event.target.value, this.props.environmentId);
        }

    }
}
